import { i18n } from "@lingui/core";
import { t } from "@lingui/macro";

export default [
  { value: "en", label: i18n._(t`English`) },
  { value: "fr", label: i18n._(t`French`) },
];
